var a = Object.defineProperty;
var d = (o, r, e) => r in o ? a(o, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : o[r] = e;
var i = (o, r, e) => d(o, typeof r != "symbol" ? r + "" : r, e);
import { EditableEntity as w } from "@zdrbm/zdr-native-tools";
class c extends w {
  constructor(e) {
    super(void 0);
    i(this, "hoveredRowIndex");
    i(this, "rows");
    this.factory = e, this.hoveredRowIndex = this.createPropEventBroker("hoveredRowIndex", -1), this.rows = this.createEntityCollection("rows", []);
  }
  removeInvalidRow(e) {
    this.getOrCreateRow(e).setValid(!0);
  }
  addInvalidRow(e) {
    this.getOrCreateRow(e).setValid(!1);
  }
  getOrCreateRow(e) {
    let t = this.rows.getItem(e.toString());
    return t || (t = this.factory.createRow(e), this.rows.appendItem(t)), t;
  }
  setSelectedRowIndices(e) {
    this.rows.getAllItems().forEach((t) => {
      t.selected.set(!1);
    }), e.forEach((t) => {
      this.getOrCreateRow(t).selected.set(!0);
    });
  }
  getRowByIndex(e) {
    return this.getOrCreateRow(e);
  }
  removeInvalidFieldIndex(e, t) {
    const s = this.getOrCreateRow(e);
    t && s.setValidField(t, !0);
  }
  addInvalidFieldIndex(e, t) {
    this.getOrCreateRow(e).setValidField(t, !1);
  }
  getEntityName() {
    return "DataGridState";
  }
}
export {
  c as DataGridState
};
//# sourceMappingURL=index.es640.js.map
